import { render, staticRenderFns } from "./FullImageCarousel.vue?vue&type=template&id=133b1dab&"
import script from "./FullImageCarousel.vue?vue&type=script&lang=js&"
export * from "./FullImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FullImageCarousel.vue?vue&type=style&index=0&id=133b1dab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports